const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, preventBackdropCloseOnDrag } =
  window.BAO.Carousel.plugins

class RecommendationsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.TAGALYS_CAROUSEL,
      () => {
        this.setupCarousel()
      },
    )
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.05,
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1.5,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        preventBackdropCloseOnDrag(),
      ],
    )
  }
}

if (!customElements.get('recommendations-carousel')) {
  customElements.define('recommendations-carousel', RecommendationsCarousel)
}
